import React, {useState} from "react";
import styled from "styled-components";
import { icons } from '../img/Icons';
import { colours } from '../Styles';
import { heights } from '../Styles';
import Navlist from './Navlist';
import ContactItem from './ContactItem';

function MobileMenu() {
    const { menu, facebook, instagram } = icons;
    const { transpBlack, light, medium } = colours;
    const {  mobileHeader, contactBar } = heights;
    let icon = menu;

  const MobileMenu = styled.div`
  display: none;
    button {
        border: none;
        background: none;
    }
    .hideMenu {
      height: 60%;
    ul {
      display: flex;
      flex-direction: column;
      height: 100%;
      align-items: center;
      justify-content: space-evenly;
      margin-top: -30%;
      li {
        color: ${light};
        font-size: 30px;
        :hover {
          color: ${medium};
        }
      }
    }
  }
    @media only screen and (max-width: 600px) {
        display: block;
    }
  `;
  const Wrapper = styled.div`
    position: absolute;
    height: calc(100vh - ${mobileHeader} - ${contactBar});
    width: 100vw;
    background: ${transpBlack};
    top: ${mobileHeader};
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .mobile-social {
      display: flex;
    }
  `;

  const [menuVisible, setVisible] = useState(false);

  function ToggleMenu() {
    setVisible(menuVisible ? false : true);
  }

  function HideMenu() {
    setVisible(false);
  }

  return (
    <MobileMenu>
        <button onClick={() => ToggleMenu()}>{icon}</button>
        {menuVisible ?       
          <Wrapper>
            <div className="hideMenu" onClick={() => HideMenu()}>
              <Navlist/>
            </div>
            <div className="mobile-social" onClick={() => HideMenu()}>
              <ContactItem icon={facebook} content="" url="https://facebook.com"/>
              <ContactItem icon={instagram} content="" url="https://www.instagram.com/precisiondetailgta/"/>
            </div>
          </Wrapper>
        : null}
    </MobileMenu>
  );
}

export default MobileMenu;